import { useSuspenseQuery } from '@tanstack/react-query'
import axios from 'axios'
import { z } from 'zod'
import { useCompetitionId } from './hooks'

const PlayerCheckResponseSchema = z.object({
  player_id: z.number().nullable(),
  team_id: z.number().nullable(),
})

type PlayerCheckResponse = z.infer<typeof PlayerCheckResponseSchema>

async function checkIsPlayer(
  competitionId: number
): Promise<PlayerCheckResponse> {
  const response = await axios.get('/api/me/player', {
    params: { competition_id: competitionId },
  })
  return PlayerCheckResponseSchema.parse(response.data)
}

export function useIsPlayer(): {
  player_id: number | null
  team_id: number | null
  competition_id: number
} {
  const competition_id = useCompetitionId()

  const { data } = useSuspenseQuery({
    queryKey: ['isPlayer', competition_id],
    queryFn: () => checkIsPlayer(competition_id),
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    gcTime: 10 * 60 * 1000,
  })

  return { ...data, competition_id }
}
